import { browserHistory } from 'react-router';

import { regexRoutesNoAuthRequired } from 'routes';

import { signOut } from '@lib/actions';
import storage from '@lib/services/storageService';
import environment from '@lib/utils/RelayEnvironment';

import { invalidateStore } from 'services/relayService';

// eslint-disable-next-line require-yield
export default function* sagaSignOut(action: ReturnType<typeof signOut>) {
  storage.removeAuth();

  // Invalidate Relay's store to ensure we don't show cached data during next session
  invalidateStore(environment);

  if (!regexRoutesNoAuthRequired.test(window.location.pathname)) {
    let path = action.payload.path || '/login';
    if (action.payload.includeReturnUrl) {
      // Add the returnUrl URL parameter to be redirected back to last path after login
      const returnUrl = encodeURIComponent(`${window.location.pathname}${window.location.search}`);
      path += `?returnUrl=${returnUrl}`;
    }
    browserHistory.push(path);
  }
}
